import { type QueryClient } from '@tanstack/react-query'
import {
  HeadContent,
  Outlet,
  createRootRouteWithContext
} from '@tanstack/react-router'

import type { AuthStore } from '@/store/useAuthStore'

import { DEFAULT_PAGE_TITLE } from '../utils/get-page-title'

export const Route = createRootRouteWithContext<{
  authStore: AuthStore | null
  queryClient: QueryClient
}>()({
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  head: () => ({
    meta: [{ title: DEFAULT_PAGE_TITLE }]
  }),

  pendingComponent: () => <div>Loading...</div>
})
